import { render, staticRenderFns } from "./settings-organization-locations.vue?vue&type=template&id=ec5d5be0&scoped=true&"
import script from "./settings-organization-locations.vue?vue&type=script&lang=js&"
export * from "./settings-organization-locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5d5be0",
  null
  
)

export default component.exports